import { useEffect } from "react";

export const useMatomo = (enabled) => {
  useEffect(() => {
    if (!enabled) return;

    window._paq = window._paq || [];
    window._paq.push(['trackPageView']);
    window._paq.push(['enableLinkTracking']);

    const u = "https://matomo.stefanlacher.com/";
    window._paq.push(['setTrackerUrl', u + 'matomo.php']);
    window._paq.push(['setSiteId', '2']);

    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];
    g.async = true;
    g.src = u + 'matomo.js';
    s.parentNode.insertBefore(g, s);

  }, [enabled]);
};
